import AlertRibbon from "./AlertRibbon";
import { RibbonProps } from "./types";

const ErrorRibbon = ({ data }: RibbonProps) => {
  const { details, setAlert } = data;

  if (details && details.errorCode) {
    return (
      <AlertRibbon
        handleClose={() => setAlert(null)}
        severity={details.type}
        message={details.message}
        errorCode={details.errorCode}
      />
    );
  }
  return null;
};

export default ErrorRibbon;
